/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './Recipient-ActionTypes';

export const enterpriseSubmitRecipient = (data) => ({
    type: actionTypes.ENTERPRISE_SAVED_RECIPIENT,
    data,
});

export const enterpriseSubmitRecipientSuccess = () => ({
    type: actionTypes.ENTERPRISE_SAVED_RECIPIENT_SUCCESS,
});

export const enterpriseSubmitRecipientFailed = () => ({
    type: actionTypes.ENTERPRISE_SAVED_RECIPIENT_FAILED,
});

export const enterpriseProceedSaveRecipient = (data) => ({
    type: actionTypes.ENTERPRISE_PROCEED_SAVED_RECIPIENT,
    data,
});

// New flow for universal checkout
export const enterpriseSaveRecipientGiftMessage = (data) => ({
    type: actionTypes.ENTERPRISE_SAVED_RECIPIENT_GIFT_MESSAGE,
    data,
});

export const enterpriseSaveRecipientGiftMessageSuccess = () => ({
    type: actionTypes.ENTERPRISE_SAVED_RECIPIENT_GIFT_MESSAGE_SUCCESS,
});

export const enterpriseSaveRecipientGiftMessageFailed = () => ({
    type: actionTypes.ENTERPRISE_SAVED_RECIPIENT_GIFT_MESSAGE_FAILED,
});

export const enterpriseQASSaveRecipient = (data) => ({
    type: actionTypes.ENTERPRISE_QAS_SAVED_RECIPIENT,
    data,
});

export const enterpriseSaveAddressBook = (data) => ({
    type: actionTypes.ENTERPRISE_SAVED_ADDRESS_BOOK,
    data,
});

export const enterpriseSaveAddressBookSuccess = () => ({
    type: actionTypes.ENTERPRISE_SAVED_ADDRESS_BOOK_SUCCESS,
});

export const enterpriseSaveAddressBookFailed = () => ({
    type: actionTypes.ENTERPRISE_SAVED_ADDRESS_BOOK_FAILED,
});
